import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const PrivateRoute = ({ element, requiredRole }) => {
  const userData = useSelector((state) => state.mainReducer.userData);

  if (!userData) {
    return <Navigate to="/" replace />;
  }

  // Superadmin bypasses all role restrictions
  if (userData.role === "superadmin") {
    return element;
  }

  if (Array.isArray(requiredRole)) {
    if (!requiredRole.includes(userData.role || "")) {
      return <Navigate to="/not-found" replace />;
    }
  } else if (typeof requiredRole === "string") {
    if (userData.role !== requiredRole) {
      return <Navigate to="/not-found" replace />;
    }
  }
  return element;
};

export default PrivateRoute;
